var _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodePipline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64258 17.8569V9.4464M9.64258 9.4464L17.1426 2.14258M9.64258 9.4464L2.14258 2.14258",
    stroke: "#91B3FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.142,
    cy: 2.14202,
    rx: 0.714286,
    ry: 0.714286,
    fill: "#91B3FA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.14202,
    cy: 2.14202,
    rx: 0.714286,
    ry: 0.714286,
    fill: "#91B3FA"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.64369,
    cy: 17.4992,
    rx: 1.07143,
    ry: 1.07143,
    fill: "#91B3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7857 2.14286C18.7857 3.05018 18.0502 3.78571 17.1429 3.78571C16.2355 3.78571 15.5 3.05018 15.5 2.14286C15.5 1.23553 16.2355 0.5 17.1429 0.5C18.0502 0.5 18.7857 1.23553 18.7857 2.14286Z",
    stroke: "#91B3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78571 2.14286C3.78571 3.05018 3.05018 3.78571 2.14286 3.78571C1.23553 3.78571 0.5 3.05018 0.5 2.14286C0.5 1.23553 1.23553 0.5 2.14286 0.5C3.05018 0.5 3.78571 1.23553 3.78571 2.14286Z",
    stroke: "#91B3FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.64258,
    cy: 17.5,
    r: 2,
    stroke: "#91B3FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5155,
    cy: 6.21081,
    r: 0.585808,
    fill: "#272D55"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1932,
    cy: 7.59362,
    r: 0.585808,
    fill: "#272D55"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1932,
    cy: 10.6171,
    r: 0.585808,
    fill: "#272D55"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5155,
    cy: 11.9139,
    r: 0.585808,
    fill: "#272D55"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83581,
    cy: 10.6171,
    r: 0.585808,
    fill: "#272D55"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83581,
    cy: 7.59362,
    r: 0.585808,
    fill: "#272D55"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5155,
    cy: 9.06237,
    r: 0.585808,
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83008 7.67585L9.46573 6.25L12.1446 7.67585M6.83008 7.67585V10.7004L9.46573 12.0398M6.83008 7.67585L9.46573 9.1449M12.1446 7.67585V10.7004L9.46573 12.0398M12.1446 7.67585L9.46573 9.1449M9.46573 12.0398V9.1449",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodePipline);
export default __webpack_public_path__ + "static/media/CodePipline.3f8e0fa2d9602df6b08e5788b25e29f2.svg";
export { ForwardRef as ReactComponent };